import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { ChannelChart } from '@/components/monitors-route/channels/chart'
import { ChannelBoard } from '@/components/monitors-route/channels/board'
import { getDailyChannelStat, getTotalEmailInQueue } from '@/api/monitor'
import { getUser } from '@/utils/auth'
import { throwException } from '@/exceptions/throw-exception.js'
import QUERY_KEY from '@/constants/use-query-key.js'

export const Route = createFileRoute('/_auth/monitors/channels')({
  component: Channel,
})

function Channel() {
  const user = getUser()

  const { isLoading: isLoadingChannelStat, data: channelStat } = useQuery({
    queryKey: [QUERY_KEY.GET_DAILY_CHANNEL_STAT],
    queryFn: async () => {
      const resp = await getDailyChannelStat()
      return resp?.data?.analytic || {}
    },
    initialData: {},
    refetchInterval: 5000,
  })

  const { data: totalEmailInQueue } = useQuery({
    queryKey: [QUERY_KEY.GET_TOTAL_EMAIL_IN_QUEUE],
    queryFn: async () => {
      const resp = await getTotalEmailInQueue(user.tenant_id)
      return resp?.data || 0
    },
    initialData: 0,
    refetchInterval: 5000,
  })

  const data = {
    facebookWait: channelStat?.totalFacebookWaiting || 0,
    facebookAnswer: channelStat?.totalFacebookAnswer || 0,
    zaloWait: channelStat?.totalZaloWaiting || 0,
    zaloAnswer: channelStat?.totalZaloAnswer || 0,
    liveChatWait: channelStat?.totalChatWaiting || 0,
    liveChatAnswer: channelStat?.totalChatAnswer || 0,
    emailAnswer: channelStat?.totalEmailAnswer || 0,
    emailWait: totalEmailInQueue || 0,
  }

  return (
    <div>
      <div>
        <ChannelChart data={data} isLoading={isLoadingChannelStat} />
      </div>
      <div className="mt-4 gap-4">
        <ChannelBoard data={data} isLoading={isLoadingChannelStat} />
      </div>
    </div>
  )
}
